import axios from "axios";
// import qs from "qs";
const baseURL = "http://api.dev.cbct.cn/"
// const headers = {headers:{"content-type":"application/x-www-form-urlencoded"}};
// export default {
// 	add(data){
// 		data = qs.stringify(data);
// 		return axios.post(baseURL+"/add",data,headers)
// 	},
// 	get(){
// 		return axios.get(baseURL+"/goods")
// 	}
// }
export default {
 post: (url,data = {}) => {
        axios.defaults.headers = {
            'Content-Type':'application/x-www-form-urlencoded',
        };
        return new Promise((resolve, reject) => {
            axios.post(url, data)
            .then (response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
  get: (url,params = {}) => {
        axios.defaults.headers = {
            'Content-Type':'application/x-www-form-urlencoded',
        };
        return new Promise((resolve, reject) => {
            axios.get(url, {params})
            .then (response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
        })
    }

    
    
}


